// ==========================
// src/App.js
// ==========================
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Navbar from './components/Navbar';
import HeroCarousel from './components/HeroCarousel';
import Section from './components/Section';
import MissionVision from './components/MissionVision';
import Objectives from './components/Objectives';
import Privacy from './components/Privacy';
import Location from './components/Location';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import theme from './theme';

export default function App(){
  return (
    <ThemeProvider theme={theme}>
      <Navbar />

      {/* HERO / INICIO */}
      <Box id="inicio">
        <HeroCarousel />
      </Box>

      {/* QUIÉNES SOMOS */}
      <Section id="quienes" title="Quiénes somos">
        En <strong>Ángel de Oro</strong> compramos tus <em>joyas de oro y plata</em> con tasaciones justas y un servicio cordial. Además, vendemos joyas nuevas de plata italiana ley 925; así como también fabricamos piezas personalizadas en oro y plata.
      </Section>

      {/* MISIÓN & VISIÓN */}
      <Section id="mision-vision" title="Misión y Visión" alt>
        <MissionVision />
      </Section>

      {/* OBJETIVOS */}
      <Section id="objetivos" title="Objetivos">
        <Objectives />
      </Section>

      {/* SERVICIOS (opcional corto) */}
      <Section id="servicios" title="Servicios">
        <ul>
          <li>Compra y venta de joyas de plata con garantía de autenticidad.</li>
          <li>Fabricación a medida en oro y plata (diseños personalizados).</li>
          <li>Limpieza y mantenimiento básico de piezas.</li>
        </ul>
      </Section>

      {/* UBICACIÓN */}
      <Section id="ubicacion" title="Dónde estamos" alt>
        <Location />
      </Section>

      {/* PRIVACIDAD Y COOKIES */}
      <Section id="privacidad" title="Privacidad y cookies">
        <Privacy />
      </Section>

      {/* CONTACTO sencillo */}
      <Section id="contacto" title="Contacto">
        <Container maxWidth="sm" sx={{ p:0 }}>
          <Typography>
            Escríbenos a <a href="mailto:info@angeldeoro.ec">info@angeldeoro.com </a> 
            o envíanos un WhatsApp al <a href="https://wa.me/593983633594" target="_blank" rel="noreferrer">093 98 363 3594</a>.
          </Typography>
        </Container>
      </Section>

      <Footer />
      <CookieBanner />
    </ThemeProvider>
  );
}
